<template>
  <fragment>
    <div>
      <input ref="ziplocation"
             type="text"
             :name="elementName"
             :id="guidId"
             :aria-describedby="ariaDescribedBy"
             :placeholder="placeHolder"
             class="FormTextbox__Input zipCodeIdentifierSpacer zipcodeIdentiferBlock"
             v-on:focus="handleFocus"
             v-on:blur="handleBlur"
             v-on:keydown.enter.prevent="submitByEnter"
             v-on:keypress="validateNumber"
             maxlength="5" />
    </div>

    <div class="loading-message" v-show="loadingLocations">Loading locations...</div>

    <div class="location-dropdown-list">
      <div v-if="loadedLocations" id="location-referrer" class="location-referrer-container zipCodeIdentifierSpacer">
        <div class="Form__Element FormSelection" data-f-element-name="__field_locationselect" data_f_type="selection">
          <label for="GUID-SOMETHING" class="Form__Element__Caption">
            If applicable, select the Simmons Bank branch that referred you to this form.
          </label>
          <select class="form-control location-list" aria-label="location select" :key="locationData.id" @change="getAdvisorsByLocation">
            <option></option>
            <option v-for="location in locationData" :name="location.id" :value="location.locationCode">{{location.address.addressLine1}}, {{location.address.city}}, {{location.address.state}}, {{location.address.zip}}</option>
          </select>
        </div>
      </div>
      <div v-else></div>
    </div>

    <div class="loading-message" v-show="loading">Loading advisors...</div>

    <div class="advisor-dropdown-list">
      <div v-if="loaded" id="advisor-referrer" class="advisor-referrer-container zipCodeIdentifierSpacer">
        <div class="Form__Element FormSelection" data-f-element-name="__field_advisorselect" data_f_type="selection">
          <label for="GUID-SOMETHING" class="Form__Element__Caption">
            If applicable, select the Simmons Bank representative that referred you to this form.
          </label>
          <select class="form-control advisor-list" aria-label="advisor select" :key="advisorData.id" @change="updateAdvisorHiddenValue">
            <option></option>
            <option v-for="advisor in advisorData" :name="advisor.id" :value="advisor.name">{{advisor.name}}</option>
          </select>
        </div>
      </div>
      <div v-else></div>
    </div>

  </fragment>

</template>

<script>
  
  import axios from "axios";
  import * as VueGoogleMaps from "vue2-google-maps";
  import Vue from "vue";
  import VueMq from "vue-mq";
  import { googleApi } from "../../../config/map";
  import { gmapApi } from 'vue2-google-maps'

  Vue.use(VueGoogleMaps, {
    load: {
      key: googleApi.geoKey,
      v: "3.40"
    },
    installComponents: false
  });
  Vue.use(VueMq, {
    breakpoints: {
      mobile: 678,
      tablet: 992,
      desktop: Infinity
    }
  });

  export default {
    data() {
      return {
        advisorData: null,
        locationData: null,
        errored: false,
        focused: false,
        loading: false,
        loadingLocations: false,
        showDefault: false,
        loaded: false,
        loadedLocations: false,
      }
    },
    mounted() {
      
      let zipcodeBlockDefault = document.getElementById('zipcode-identifier-block')
      let zipcodeInputId = document.getElementById(this.guidId)

      //console.info("attributesString", this.attributesString, this.attributesString.indexOf("required") !== -1);
      if (this.attributesString.indexOf("required") !== -1) {
        zipcodeInputId.setAttribute("required", "");
        zipcodeInputId.setAttribute("aria-required", "true");
      }
      
      var destinationItem = $('.zipcodeIdentiferBlock').parent();
      var zipCodeIdentiferBlockAriaDescribedByValue = $('.zipcodeIdentiferBlock').attr('aria-describedby');
      var sourceItem = $('#' + zipCodeIdentiferBlockAriaDescribedByValue);
      if (sourceItem.length > 0) {
        $(sourceItem).appendTo(destinationItem);  
      }
       
      
      //if (this.zipcode) {
      //  featuredAdvisorInput.value = this.zipcode
      //  this.getAdvisors(this.latitude, this.longitude)
      //  advisorsBlockDefault.classList.remove('default-advisors-active')
      //} else {
      //  advisorsBlockDefault.classList.add('default-advisors-active')
      //  this.showDefault = true
      //}
      //zipcodeBlockDefault.classList.add('default-advisors-active')
      this.showDefault = false
    },
    computed: {
      google: gmapApi
    },
    methods: {
      async updateAdvisorHiddenValue(event) {
        var advisorEmail = event.target.value;
        var hiddenAdvisorValue = $('.EPiServerForms').find($('input:hidden[data-default-value="{advisor-list}"]'));

        if ($(hiddenAdvisorValue).length > 0) {
          $(hiddenAdvisorValue).val(advisorEmail)
        }
      },

      async getAdvisorsByLocation(event) {
       
        var locationId = event.target.value;
        var advisorType = $('.advisorTypeFilter').val();
        let advisorApi = '/api/advisors-by-location?locationCode=' + locationId + "&advisorType=" + advisorType;

        var hiddenLocationValue = $('.EPiServerForms').find($('input:hidden[data-default-value="{location-list}"]'));
        if ($(hiddenLocationValue).length > 0) {
          $(hiddenLocationValue).val(locationId)
        }
        
        //this.loading = true
        axios
          .get(advisorApi)
          .then(response => {
            
            this.loading = false
            this.advisorData = response.data.advisors
            
            this.loaded = true
            //if (typeof HERO_bootstrapCarousel != "undefined") {
            //  setTimeout(function () {
            //    HERO_bootstrapCarousel.init();
            //  }, 1000);
            //}

            console.info("response.data.advisors",response.data.advisors)
            // check for data
            if (this.advisorData.length <= 0) {
              this.errored = true
              this.loaded = false
              //advisorsBlockDefault.classList.add('default-advisors-active')
            }
          })
          .catch(error => {
            console.log(error)
            this.errored = true
          })
      },

      async getLocations(radius, lat, long) {

        //hide advisors
        this.loaded = false
        this.loading = false

        let locationApi = '/api/locations?lat=' + lat + '&lng=' + long + '&radius=' + radius + '&includeAssociateOnly=true';
        this.loadingLocations = true
        //let advisorsBlockDefault = document.getElementById('zipcode-identifier')
        axios
          .get(locationApi)
          .then(response => {
            //console.info("get locations called")
            //advisorsBlockDefault.classList.remove('default-advisors-active')
            this.loadingLocations = false
            this.locationData = response.data.locations
            
            this.loadedLocations = true
            //if (typeof HERO_bootstrapCarousel != "undefined") {
            //  setTimeout(function () {
            //    HERO_bootstrapCarousel.init();
            //  }, 1000);
            //}

            //console.info("response.data.locations",response.data.locations)
            // check for data
            if (this.locationData.length <= 0) {
              this.errored = true
              this.loadedLocations = false

              if (radius == '5') {
                this.getLocations('10',lat, long)
              }

              if (radius == '10') {
                this.getLocations('20',lat, long)
              }
              
              //advisorsBlockDefault.classList.add('default-advisors-active')
            }
          })
          .catch(error => {
            console.log(error)
            this.errored = true
          })
      },
      
      async submitByEnter() {
        this.errored = false;
        let inputValue = this.$refs.ziplocation.value
        //console.info("inputValue",inputValue)
        this.loadedLocations = false
        this.loading = false
        //let latitude = ''
        //let zipcodeBlockDefault = document.getElementById('zipcode-identifier-block')
        if (!inputValue) {
          this.focused = true
          
          this.errored = false
          // advisorsBlockDefault.classList.add('default-advisors-active')
        } else {
          if (inputValue.length == 5 && !isNaN(inputValue)) {
            var _ = this;
            let longitude = '';
            let latitude = '';
            _.$gmapApiPromiseLazy().then(() => {

              let geocoder = new _.google.maps.Geocoder();
              geocoder.geocode({ 'address': 'zipcode ' + inputValue }, (results, status) => {
                
                if (status == _.google.maps.GeocoderStatus.OK) {
                  this.loadingLocations = true
                  this.loading = false

                  latitude = results[0].geometry.location.lat()
                  longitude = results[0].geometry.location.lng()
                  //console.info("latlng",latitude,longitude)
                  
                  this.getLocations('5',latitude, longitude)

                  //var locationId = "LOC_0025";
                  //this.getAdvisorsByLocation(locationId)

                  return results

                } else {
                  console.error("Request failed.")
                  this.errored = false
                }
              });
            });
          } else {
            this.errored = true
          }
        }
      },
      handleBlur() {
        this.submitByEnter()
      },
      handleFocus() {
        this.focused = true
      },
      validateNumber(event) {
        let keyCode = event.keyCode;
        if (keyCode < 48 || keyCode > 57) {
          event.preventDefault();
        }
      }
    },
    props: {
      elementName: String,
      guidId: String,
      ariaDescribedBy: String,
      placeHolder: String,
      attributesString: String
    },
    watch: {
    }
  }
</script>
